import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
 
@Injectable({
   providedIn: 'root'
})
 
export class MetaService { 
   constructor(@Inject(DOCUMENT) private dom) { }
    
   createCanonicalURL(url?: string) {

      const existingCanonical = this.dom.head.querySelector('link[rel="canonical"]');
      if (existingCanonical) {
         existingCanonical.remove();
      }

      let link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.dom.head.appendChild(link);

      const canonicalUrl = this.normalizeCanonicalURL(url || this.dom.URL);
      if (canonicalUrl) {
         link.setAttribute('href', canonicalUrl);
      }
   }

   private normalizeCanonicalURL(url?: string): string {
      const siteUrl = 'https://www.myreferralpromocode.com';
      if (!url) {
         return `${siteUrl}/`;
      }

      let pathname = '/';
      try {
         pathname = new URL(url, siteUrl).pathname;
      } catch {
         pathname = url.replace(siteUrl, '').split(/[?#]/)[0] || '/';
      }

      const cleanPath = pathname.replace(/^\/+|\/+$/g, '');
      return cleanPath ? `${siteUrl}/${cleanPath}/` : `${siteUrl}/`;
   }
} 
